export function LoadingState({ label }: { label: string }) {
  return (
    <section className="classic-state-panel" role="status" aria-live="polite">
      <h1>{label}</h1>
      <p>Fetching profile...</p>
    </section>
  );
}

export function ErrorState({
  title,
  error,
}: {
  title: string;
  error: unknown;
}) {
  const detail = error instanceof Error ? error.message : 'Something unexpected happened.';
  return (
    <section className="classic-state-panel classic-state-error" role="alert">
      <h1>{title}</h1>
      <p>{detail}</p>
      <button type="button" onClick={() => window.location.reload()}>Try again</button>
    </section>
  );
}
